const angular = require('angular');
const ngSanitize = require('angular-sanitize');
const uiRouter = require('angular-ui-router');
const restangular = require('restangular'); // eslint-disable-line no-unused-vars

const olyCommonModule = require('../olycommon/olycommon.module');
const wowCommonModule = require('../common/common.module');

const { SearchService } = require('./search.service');
const { SearchPhraseActionService } = require('./search-phrase-action.service');
const { searchMultisearchComponentDefinition } = require('./search-multisearch.component');
const { searchNavigationComponentDefinition } = require('./search-navigation.component');
const { searchNavigationLinkComponentDefinition } = require('./search-navigation-link.component');
const { searchProductTileListComponentDefinition } = require('./search-product-tile-list.component');
const { searchRecipeTileListComponentDefinition } = require('./search-recipe-tile-list.component');
const { searchInspirationTileListComponentDefinition } = require('./search-inspiration-tile-list.component');
const { searchTermTileListUpdaterComponentDefinition } = require('./search-term-tile-list-updater.component');
const { searchZeroResultComponentDefinition } = require('./search-zero-results.component');


const searchModuleName = 'wowApp.search';

angular.module(searchModuleName, [olyCommonModule, wowCommonModule, ngSanitize, uiRouter, 'restangular'])
    .service('SearchService', SearchService)
    .service('SearchPhraseActionService', SearchPhraseActionService)
    .service('SearchMultisearchService', ['Restangular', 'BreakpointsService', '$stateParams', 'LocalStorageWrapper', require('./search-multisearch.service')])
    .component('wowMultisearch', searchMultisearchComponentDefinition)
    .component('wowSearchNavigation', searchNavigationComponentDefinition)
    .component('wowSearchNavigationLink', searchNavigationLinkComponentDefinition)
    .component('wowSearchProductTileList', searchProductTileListComponentDefinition)
    .component('wowSearchRecipeTileList', searchRecipeTileListComponentDefinition)
    .component('wowSearchInspirationTileList', searchInspirationTileListComponentDefinition)
    .component('wowSearchTermTileListUpdater', searchTermTileListUpdaterComponentDefinition)
    .component('wowSearchZeroResults', searchZeroResultComponentDefinition)
    .directive('wowSearchExternalResult', ['$sce', 'SettingsService', '$stateParams', 'SearchPhraseActionService', '$state', 'ShopperService', require('./search-externalresult.directive')]);

module.exports = searchModuleName;



// WEBPACK FOOTER //
// ./src/search/search.module.js